import { ProductionIndicatorSVG } from "./ProductionIndicatorSVG";
export default ProductionIndicatorSVG;
